<template>
    <b-modal
            id="import-xero-pay-calendars"
            ref="import-xero-pay-calendars"
            size="lg-size"
            modal-class="modal-xero"
            no-close-on-esc
            no-close-on-backdrop
            centered
            hide-footer
            hide-header
            @hide="close"
    >
        <div class="modal-head">
            <h2 class="modal-title">{{'Update Pay Calendars'}}</h2>
            <div class="quickbooks-logo">
                <img
                        src="/assets/images/xero-logo-blue.svg"
                        alt="Atto"
                        class="black-logo"
                        width="50"
                        height="50"
                >
            </div>
        </div>
        <div class="content-wrapper">
            <p>
                {{'If you’ve changed an employee’s pay calendar in Xero, it is important to synchronize that setting to Atto. When you click on Update, the pay calendars will be updated in the background automatically.'}}
            </p>
            <span v-if="errorMessage" class="error-message">
                {{errorMessage}}
            </span>
        </div>
        <div class="modal-footer">
            <button
                    type="reset"
                    class="atto-btn cancel"
                    data-dismiss="modal"
                    @click="close"
            >
                {{label.get('cancel')}}
            </button>
            <button
                    class="atto-btn submit"
                    type="submit"
                    @click="submit"
            >
                {{label.get('Update')}}
            </button>
        </div>
    </b-modal>
</template>

<script>
    import CompanyService from "../services/CompanyService";
    import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";

    export default {
        name: "ImportXeroPayCalendarsComponent",
        data() {
            return {
                errorMessage : ''
            }
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$store.commit('showLoading');
            this.$refs['import-xero-pay-calendars'].show();
            this.$store.commit('hideLoading');
        },
        methods: {
            submit() {

                this.$store.commit('showLoading');
                CompanyService.updatePayCalendars().then((result) => {
                    debugger;
                    this.$store.commit('hideLoading');
                    this.$awn.success('Pay calendars updates successfully');
                    this.$root.$emit('hideXeroPayCalendars');
                }).catch(error => {
                    this.$store.commit('hideLoading');
                    if(error.response.status === 403 ){
                        this.$store.commit('xeroHasError403', true);
                        this.$root.$emit('showXeroErrors');
                    }
                    this.errorMessage = error.response.data.error.message;
                });

            },
            close() {
                this.$root.$emit('hideXeroPayCalendars');
            }
        }
    }
</script>

<style lang="scss" scoped>



</style>